import React from "react";
import { toAbsoluteUrl } from "../../../../../../_metronic/_helpers";
import BusSection from "./BusSection";
import Confirmation from "./Confirmation";
import ExtraWeight from "./ExtraWeight";
import { Button } from "@material-ui/core";
import { CompareArrows } from "@material-ui/icons";
import { useHistory } from "react-router-dom";
import {
  useDispatch,
  useSelector,
} from "../../../../../utils/react-redux-hooks";
import { actions } from "../../../../SearchPage/_redux/searchRedux";
import queryStringParse from "../../../../../../functions/queryParam";
import GetUserInformation from "./GetUserInformation"
import * as Scroll from "react-scroll";

const ReserveFirstStep = (props) => {
  const { state } = useSelector((state) => ({
    state: state.search,
  }));

  let scroll = Scroll.animateScroll;

  React.useEffect(() => {
    scroll.scrollToTop();
  }, []);

  const changeTicket = () => {
    if (state.props.date2) {
      history.push(
        {
          pathname: `/bus-ticket/${state.props.source_id}/${state.props.dest_id}`,
          search: `?date=${state.props.date2},${state.props.date}&count=${state.props.count}`,
        }
        // `/bus-ticket/${state.props.source_id}/${state.props.dest_id}?date=${state.props.date2},${state.props.date}&count=${state.props.count}`
      );
    } else if (!state.props.date2) {
      history.push(
        {
          pathname: `/bus-ticket/${state.props.source_id}/${state.props.dest_id}`,
          search: `?date=${state.props.date}&count=${state.props.count}`,
        }
        // `/bus-ticket/${state.props.source_id}/${state.props.dest_id}?date=${state.props.date}&count=${state.props.count}`
      );
    }
  };

  const history = useHistory();
  const dispatch = useDispatch();

  const hourManager = (time) => {
    if (time) {
      const splittedTime = time
        .split("T")[1]
        .split(".")[0]
        .split(":");
      return `${splittedTime[0]}:${splittedTime[1]}`;
    }
  };

  //Extract Travel Porps From URL
  const urlTrimmer = () => {
   
    const trimmedURL = history.location.pathname.split("/");
    const date2condition = trimmedURL[4].split(",");

    if (date2condition.length > 1) {
      const props = {
        date2: date2condition[0],
        date: date2condition[1],
        count: trimmedURL[7],
        source_id: trimmedURL[2],
        dest_id: trimmedURL[3],
        travelId: trimmedURL[5],
      };
      dispatch(actions.props(props));
    } else {
      const props = {
        date: date2condition[0],
        count: trimmedURL[6],
        source_id: trimmedURL[2],
        dest_id: trimmedURL[3],
        travelId: trimmedURL[5],
      };
      dispatch(actions.props(props));
    }
  };

  const persianDateHandler = () => {
    let params=[];

    
    if (history.location.search ) {
      var search = history.location.search;
       params = queryStringParse(search);
   
   }
  //  const urlDate = params.date;
    const urlDate = history.location.pathname.split("/")[4];
    let dateOptions = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    };

    const persianDate = new Date(urlDate).toLocaleDateString(
      "fa-Ir",
      dateOptions
    );

    const day = persianDate.split(",")[1];
    const monthAnddate = persianDate.split(",")[0].split(" ");

    const mixed = `${day}, ${monthAnddate[2]} ${monthAnddate[1]}`;

    return mixed;
  };

  React.useEffect(() => {
    urlTrimmer();
    dispatch(actions.setTotalPrice(0));
  }, []);

  return (
    <>
      <div
        className="shdow-sm container"
        style={{
          marginBlock: "5rem",
          borderRadius: "13px",
        }}
      >
        <div
          className="bg-white container d-md-flex d-sm-block py-3"
          style={{
            minHeight: 150,
            border: "1px solid darkgray",
            borderRadius: "13px",
          }}
        >
          <div className="col-sm-12 col-md-9 d-block container">
            <div className="mb-10 mt-5 d-flex justify-content-between">
              <h2 className="text-right" >
                <b>{persianDateHandler()}</b>
              </h2>
              <a
                style={{ textDecoration: "none", color: "green" }}
                className="d-md-none"
                onClick={() => {
                  changeTicket();
                }}
              >
                <i
                  className="fa fa-edit"
                  style={{ color: "#6dd06d", cursor: "pointer" }}
                ></i>
                <span
                  style={{ fontSize: 15, marginRight: 5, color: "#6dd06d" }}
                >
                  تغییر بلیط
                </span>
              </a>
            </div>
            <div className="d-flex">
              <h3 style={{ opacity: "0.85" }} className="my-auto">
                <b>
                  {state?.travelDetails?.directionInfo?.departureDatetime
                    ? hourManager(
                        state?.travelDetails?.directionInfo?.departureDatetime
                      )
                    : null}
                </b>
              </h3>
              <div
                className="line  w-100"
                style={{ marginBottom: "1.9%" }}
              ></div>
              <h3 className="my-auto" style={{ opacity: "0.85" }}>
                <b>
                  {" "}
                  {state?.travelDetails?.arrivedTime
                    ? hourManager(state?.travelDetails?.arrivedTime)
                    : null}
                </b>
              </h3>
            </div>
            <div className="d-flex justify-content-between">
              <h6 style={{ opacity: "0.7" }} className="my-auto">
                {" "}
                ترمینال{" "}
                {state.travelDetails?.townshipsInfo?.sourceTownshipTitle}
              </h6>
              <h6 style={{ opacity: "0.7" }} className='my-auto'>
                {" "}
                ترمینال {state.travelDetails?.townshipsInfo?.destTownshipTitle}
              </h6>
            </div>

            <div className="d-flex justify-content-between ">
              {/* <div
                className="d-flex  dg1-border p-4 w-auto"
                style={{ gap: 10, borderRadius: 20, marginTop: 20 }}
              >
                <img
                  src={toAbsoluteUrl("/media/ebusCardLogos/Group 62.png")}
                  alt=""
                />
                <img
                  src={toAbsoluteUrl("/media/ebusCardLogos/Group 63.png")}
                  alt=""
                />
                <img
                  src={toAbsoluteUrl("/media/ebusCardLogos/Group 64.png")}
                  alt=""
                />
              </div> */}
            </div>
          </div>
          <div className="connect-line d-none d-md-block"></div>
          <div
            className="col-sm-12 col-md-3 d-none d-md-flex flex-column justify-content-center"
            style={{ width: "20rem" }}
          >
            <Button
              className="btn align-self-center"
              style={{
                borderRadius: '13px',
                backgroundColor: "#6dd06d",
                whiteSpace: "nowrap",
                height: "4rem",
                width: "100%",
              }}
              onClick={() => changeTicket()}
            >
              <h5
                style={{ fontSize: "16px", color: "#6dd06d" }}
                className="mx-auto my-auto text-white"
              >
                تغییر بلیط
              </h5>
            </Button>
          </div>
        </div>
      </div>
      <div className="container">
        <div
          className="bg-white dg1-border container py-3"
          style={{ borderRadius: "13px" }}
        >
          <h2 className="mt-5 mb-15">
            <b>انتخاب صندلی</b>
          </h2>
          <BusSection dynamicPrice/>
        </div>
      </div>

      <div className="container" style={{marginBlock:" 4rem 2rem"}}>
          <GetUserInformation step={props.step} handleComplete={props.handleComplete}/>
      </div>

      {/* <ExtraWeight /> */}
      {/* <Confirmation handleComplete={props.handleComplete} /> */}
    </>
  );
};

export default ReserveFirstStep;
